export default __webpack_public_path__ + "static/about-2-f808226637a908ebd72be83473a23dd8.webp";